import { render } from "./delButton.vue?vue&type=template&id=2c3b6fee&scoped=true"
import script from "./delButton.vue?vue&type=script&lang=js"
export * from "./delButton.vue?vue&type=script&lang=js"

import "./delButton.vue?vue&type=style&index=0&id=2c3b6fee&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3b6fee"]])

export default __exports__